export const FORM_ERROR = 'Preencha corretamente os campos antes de salvar'
